import React, { useState } from "react";
import { Row } from "react-bootstrap";
import styled from "styled-components";
import BuyTabMenu from "./BuyTabMenu";
import DistributeTabMenu from "./DistributeTabMenu";
import ProductTabMenu from "./ProductTabMenu";
import StoreTabMenu from "./StoreTabMenu";
import UsersTabMenu from "./UsersTabMenu";

const Holder = styled(Row)`
  width: 100%;
  padding: ${(props) => props.allowPaddings ? '1.5rem 0 1.1rem 0' : '0 0 0.5rem 0'};


  @media (max-width: 900px) {
    padding-bottom: ${(props) => props.allowPaddings ? '2.5rem' : '0'};
  }
`;

const TabMenues = ({
  onCollapse,
  onCreateSuccess,
  currentTab,
  currentData,
}) => {
  return (
    <Holder allowPaddings={currentTab != 'users'}>
      {currentTab === "buy" && (
        <BuyTabMenu
          tabData={currentData}
          onCollapse={onCollapse}
          onCreateSuccess={onCreateSuccess}
        />
      )}
      {currentTab === "distribute" && (
        <DistributeTabMenu
          tabData={currentData}
          onCollapse={onCollapse}
          onCreateSuccess={onCreateSuccess}
        />
      )}
      {currentTab === "product" && (
        <ProductTabMenu
          tabData={currentData}
          onCreateSuccess={onCreateSuccess}
        />
      )}
      {currentTab === "store" && <StoreTabMenu tabData={currentData} />} 
      {/* {currentTab === "users" && <UsersTabMenu tabData={null} />}  */}
    </Holder>
  );
};

export default TabMenues;
